/** Image lazy-loading */
let lazyImages = [];
document.addEventListener('DOMContentLoaded', function () {
    lazyImages = [].slice.call(document.querySelectorAll('img.lazy'));
    let tabs = document.getElementsByClassName('qodef-tabs-nav')[0];
    let active = false;
    const lazyLoad = function () {
        if (active === false) {
            active = true;

            lazyImages.forEach(function (lazyImage) {
                let bcRect = lazyImage.getBoundingClientRect().top;
                let validTop = bcRect > 0 && bcRect <= window.innerHeight;

                if ((validTop && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== 'none') {
                    lazyImage.src = lazyImage.dataset.src;
                    lazyImage.srcset = lazyImage.dataset.srcset;
                    lazyImage.classList.remove('lazy');

                    lazyImages = lazyImages.filter(function (image) {
                        return image !== lazyImage;
                    });

                    if (lazyImages.length === 0) {
                        document.removeEventListener('scroll', lazyLoad);
                        window.removeEventListener('resize', lazyLoad);
                        window.removeEventListener('orientationchange', lazyLoad);
                        if (tabs) {
                            tabs.removeEventListener('click', lazyLoad);
                        }
                    }
                }
            });


            active = false;
        }
    };

    lazyLoad();
    document.addEventListener('scroll', lazyLoad);
    window.addEventListener('resize', lazyLoad);
    window.addEventListener('orientationchange', lazyLoad);
    if (tabs) {
        tabs.addEventListener('click', lazyLoad);
    }


    let socialLinks = document.getElementsByClassName('qodef-share-link');

    for (let i = 0; i < socialLinks.length; i++) {
        socialLinks[i].addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let link = this.dataset.link;
            link = JSON.parse(link);
            console.log(link);
            window.open(link.url, link.type, link.options);
        }, false);
    }


    function createListItem(item, config) {
        let view_class = config && config.view ? config.view : 'normal';

        var li = document.createElement('div');
        li.className += "result-container flex-stretch " + view_class;

        var container = document.createElement('a');
        container.href = item.url;
        container.target = '_blank';
        container.title = item.title;
        container.classList.add('result-holder');

        var info = document.createElement('div');
        info.classList.add('info');

        var cat = document.createElement('p');
        cat.classList.add('category');
        cat.innerHTML = item.type_name + ' <img src="' + item.icon_url + '" alt="' + item.type_name + ' Ikone" class="cat-ico">';

        var title = document.createElement('div');
        title.classList.add('title');
        title.innerHTML = '<h4>' + item.title + '</h4>';

        info.appendChild(cat);
        info.appendChild(title);

        if (item.date) {
            var date = document.createElement('p');
            date.innerHTML = '<p>Termin: ' + item.date + '</p>';
            info.appendChild(date);
        }

        if (item.duration) {
            let duration = document.createElement('p');
            duration.classList.add('duration');
            duration.innerHTML = '<p>Dauer: ' + item.duration + '</p>';
            info.appendChild(duration);
        }

        if (item.location) {
            var location = document.createElement('p');
            location.innerHTML = '<p>Ort: ' + item.location + '</p>';
            info.appendChild(location);
        }

        if (item.excerpt) {
            var excerpt = document.createElement('p');
            excerpt.classList.add('teaser');
            excerpt.innerHTML = item.excerpt;
            info.appendChild(excerpt);
        }

        var image = document.createElement('div');
        image.classList.add('image');
        var img = document.createElement('img');
        img.src = item.image ? item.image : '';
        image.appendChild(img);

        container.appendChild(image);
        container.appendChild(info);


        var buyInfo = document.createElement('div');
        // var price = document.createElement('p');
        // price.classList.add('price');
        // price.innerText = ' €';
        // buyInfo.appendChild(price);
        var actions = document.createElement('div');
        buyInfo.classList.add('buy-info');
        actions.classList.add('actions');
        var detailsBtn = document.createElement('a');
        detailsBtn.title = 'Produktdetails anzeigen';
        detailsBtn.target = '_blank';
        detailsBtn.classList.add('action-btn')
        detailsBtn.href = item.post_url;
        detailsBtn.innerHTML = '<img src="/wp-content/themes/coney/assets/img/details.svg" alt="" class="cat-ico">';

        actions.appendChild(detailsBtn);
        buyInfo.appendChild(actions);
        container.appendChild(buyInfo);


        li.appendChild(container)
        return li;
    }

    function renderRestItems(items, config) {
        var resContainer = document.getElementById('sta-search-results');
        resContainer.innerHTML = '';
        if (items && items.length) {
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                let li = createListItem(item, config);
                resContainer.appendChild(li);
            }
        } else {
            var noResult = document.createElement('p');
            noResult.style.margin = '0 15px'
            noResult.innerHTML = 'Keine Ergebnisse gefunden.';
            resContainer.appendChild(noResult);
        }
    }

    document.render_rest_items = renderRestItems;


    // go-back btn

    let goBack = document.getElementById('sta-go-back');
    if (goBack) {
        if (document.referrer.includes(location.host)) {
            goBack.style.display = 'inline-block';
        }
    }
});
